{
  "id": "updated-pm",
  "label": "Uppdaterat-pm",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "planning": {
    "titlePattern": "Uppdaterat pm från TT {dayName} den {dateRange}",
    "slugline": "TT-uppdaterat-pm {fromDate}"
  },
  "sources": [
    { "type": "planning", "newsvalues": ["4", "5", "6"] }
  ],
  "postamble": [
    "Frågor om TT:s planering besvaras av tjänstgörande nyhetschef som nås på telefon 08-692 27 00. Redaktionen nås på redaktionen@tt.se.",
    "TT:s planeringar för text, grafik och bild/video kan även följas här: https://tt.se/planering/lista/, samt TT:s kalender: https://tt.se/kalender/lista/.",
    "TT Nyhetsbyrån"
  ],
  "blocks": [
    {
      "id": "todays-material",
      "label": "Dagens material",
      "preamble": ["God middag, följande material kan ni räkna med att få från TT i dag:"],
      "grouping": "section",
      "sectionHeadings": [
        { "section": "Inrikes", "heading": "Inrikes" },
        { "section": "Utrikes", "heading": "Utrikes" },
        { "section": "Ekonomi", "heading": "Ekonomi" },
        { "section": "Kultur och nöje", "heading": "Kultur och nöje" },
        { "section": "Sport", "heading": "Sport" }
      ],
      "otherSectionHeading": "Övrigt",
      "topNews": { "heading": "Toppnyheter", "types": ["planning"], "newsvalues": ["5", "6"] },
      "item": {
        "headline": "{headline}",
        "lines": ["{publicDescription}"],
        "assignmentLines": [
          { "types": ["text"], "pattern": "Text: {slugline}: {assignmentTitle}" },
          {
            "types": ["picture", "picture/video", "video"],
            "labels": {
              "picture": "Bild",
              "picture/video": "Bild/video",
              "video": "Video"
            },
            "pattern": "{assignmentLabel}: {assignmentTitle}"
          }
        ]
      }
    }
  ]
}
